module.exports = "/_next/static/images/TopWorkplaces-2022-2026-7646d9e6ee756469d51f913234b22f15.png";